import lookUpReducer from "./lookUpSlice";

export default lookUpReducer;
